import { render, staticRenderFns } from "./PriceFormView.vue?vue&type=template&id=2c899368"
import script from "./PriceFormView.vue?vue&type=script&lang=js"
export * from "./PriceFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports